export default __webpack_public_path__ + "static/media/icon_monitor.18a6a9c4.svg";